"use client";

import React from "react";
import Heading from "@components/heading"; // Ensure correct import path

const PrivacyPolicy = () => {
  return (
    <div className="w-2/3 mx-auto p-6">
      <Heading level="h1">Privacy Policy</Heading>
      <p className="text-gray-600">Last updated: December 29, 2024</p>

      <p>
        This Privacy Policy describes how CF Organic Wellness Shop (the &quot;Site&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;)
        collects, uses, and discloses your personal information when you visit, use our services, or
        make a purchase from www.cforganicwellness.com (the &quot;Site&quot;) or otherwise communicate with us
        regarding the Site (collectively, the &quot;Services&quot;).
      </p>

      <Heading level="h2">Please Read This Privacy Policy Carefully</Heading>

      <Heading level="h2">Changes to This Privacy Policy</Heading>
      <p>
        We may update this Privacy Policy from time to time, including to reflect changes to our practices
        or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on
        the Site, update the &quot;Last updated&quot; date, and take any other steps required by applicable law.
      </p>

      <Heading level="h2">How We Collect and Use Your Personal Information</Heading>
      <p>
        To provide the Services, we collect personal information about you from a variety of sources. The
        information that we collect and use varies depending on how you interact with us.
      </p>

      <Heading level="h2">What Personal Information We Collect</Heading>
      <p>
        The types of personal information we obtain about you depend on how you interact with our Site and
        use our Services. We define &quot;personal information&quot; as data that identifies, relates to, or can be
        associated with you.
      </p>

      <Heading level="h3">Information We Collect Directly from You</Heading>
      <ul className="list-disc ml-6">
        <li>Contact details including your name, address, phone number, and email.</li>
        <li>Order information including your billing/shipping address and payment confirmation.</li>
        <li>Account details such as username, password, and security questions.</li>
        <li>Customer support interactions, including messages you send us.</li>
      </ul>

      <Heading level="h3">Information We Collect about Your Usage</Heading>
      <p>
        We automatically collect certain information about your interaction with the Services (&quot;Usage Data&quot;).
        This includes device information, browser details, IP address, and other interaction details.
      </p>

      <Heading level="h3">Information We Obtain from Third Parties</Heading>
      <p>
        We may also collect personal information from third parties, including vendors and service providers
        such as Yewly and payment processors.
      </p>

      <Heading level="h2">How We Use Your Personal Information</Heading>
      <p>
        We use personal information to provide, improve, and protect the Services, as well as for security,
        marketing, and legal compliance.
      </p>

      <Heading level="h3">Marketing and Advertising</Heading>
      <p>
        We may use your personal information for marketing and promotional purposes, including sending
        newsletters and targeted advertisements.
      </p>

      <Heading level="h3">Security and Fraud Prevention</Heading>
      <p>
        We take measures to prevent fraud and protect user data. If you suspect an account breach, contact
        us immediately.
      </p>

      <Heading level="h3">Cookies</Heading>
      <p>
        Like many websites, we use cookies to improve user experience, track engagement, and run analytics.
        You can manage cookie preferences in your browser settings.
      </p>

      <Heading level="h2">How We Disclose Personal Information</Heading>
      <p>
        We may share personal information with vendors, business partners, and affiliates to provide the
        Services effectively.
      </p>

      <Heading level="h2">Third-Party Websites and Links</Heading>
      <p>
        Our Site may contain links to third-party websites. We are not responsible for their privacy
        policies and encourage you to review their terms before providing personal information.
      </p>

      <Heading level="h2">Children’s Data</Heading>
      <p>
        Our Services are not intended for children, and we do not knowingly collect data from individuals
        under 16 years of age.
      </p>

      <Heading level="h2">Security and Retention of Your Information</Heading>
      <p>
        While we implement security measures to protect personal data, no system is completely secure. We
        encourage you to use strong passwords and secure your account credentials.
      </p>

      <Heading level="h2">Your Rights</Heading>
      <p>
        Depending on your location, you may have rights such as accessing, correcting, or deleting your
        personal information.
      </p>

      <Heading level="h2">Complaints</Heading>
      <p>
        If you have concerns about our privacy practices, you may contact us. In some cases, you may also
        have the right to appeal our decision or escalate your complaint to a regulatory authority.
      </p>

      <Heading level="h2">International Users</Heading>
      <p>
        We may store and process personal data outside your country, in compliance with applicable data
        protection laws.
      </p>

      <Heading level="h2">Contact Us</Heading>
      <p>
        For any questions about this Privacy Policy, please email us at{" "}
        <a href="mailto:info@cforganicwellness.com" className="text-blue-500 hover:underline">
          info@cforganicwellness.com
        </a>{" "}
        or visit us at 9 Hugh Barn Lane, New Longton, Preston, ENG, PR4 4XA, GB.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
